import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  LOCATIONS_FEATURE_KEY,
  locationState,
  LocationsPartialState,
  locationsAdapter,
} from './locations.reducer';

// Lookup the 'Locations' feature state managed by NgRx
export const getLocationsState = createFeatureSelector<
  LocationsPartialState,
  locationState
>(LOCATIONS_FEATURE_KEY);

const { selectAll, selectEntities } = locationsAdapter.getSelectors();

export const getLocationsLoaded = createSelector(
  getLocationsState,
  (state: locationState) => state.loaded
);

export const getLocationsError = createSelector(
  getLocationsState,
  (state: locationState) => state.error
);

export const getAllLocations = createSelector(
  getLocationsState,
  (state: locationState) => selectAll(state)
);

export const getLocationsEntities = createSelector(
  getLocationsState,
  (state: locationState) => selectEntities(state)
);

export const getLocationSelectedId = createSelector(
  getLocationsState,
  (state: locationState) => state.selectedId
);

export const getLocationSelected = createSelector(
  getLocationsEntities,
  getLocationSelectedId,
  (entities, selectedId) => selectedId && entities[selectedId]
);

export const getLocationsNextPage = createSelector(
  getLocationsState,
  (state: locationState) => state.nextPage
);

export const getLocationAdministrators = createSelector(
  getLocationsState,
  (state: locationState) => state.administrators
);

export const getLocationPagination = createSelector(
  getLocationsState,
  (state: locationState) => state.pagination
);

export const getSelectedAministrator = createSelector(
  getLocationsState,
  (state: locationState) =>
    state.selectedAdministratorId &&
    state.administrators.filter((a) => a.id == state.selectedAdministratorId)
      .length
      ? state.administrators.filter(
          (a) => a.id == state.selectedAdministratorId
        )[0]
      : null
);

export const getLocationRoles = createSelector(
  getLocationsState,
  (state: locationState) => state.roles
);
